var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nf-header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.hideNfHead && JSON.stringify(_vm.$route.meta) !== '{}'),expression:"!$route.meta.hideNfHead && JSON.stringify($route.meta) !== '{}'"}]}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }